import React from 'react';
import MetricCard from './MetricCard';

interface Metric {
  label: string;
  value: string;
  trend: string;
  progress: number;
  highlight?: boolean;
}

const HeroSection: React.FC = () => {
  const metrics: Metric[] = [
    {
      label: "Development Phase",
      value: "ALPHA",
      trend: "↑ In Progress",
      progress: 45
    },
    {
      label: "Global Reach",
      value: "2",
      highlight: true,
      trend: "◉ West Africa & Europe",
      progress: 65
    },
    {
      label: "Platform Launch",
      value: "Q4 2025",
      trend: "◉ On Schedule",
      progress: 30
    }
  ];

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="brand-label"></div>
        <h1 className="hero-title">
          Building bridges <span className="highlight">between ideas and execution</span>
        </h1>
        <p className="hero-subtitle">
          At Ainaeco, we stand at the intersection of creativity and implementation, 
          empowering businesses to navigate the journey from ideation to execution with confidence. 
          Our collaborative approach combines technological facilitation with deep sector insights, 
          creating bespoke solutions that elevate experiences and drive operational excellence.
        </p>
        
        <div className="dashboard-grid">
          {metrics.map((metric, index) => (
            <MetricCard key={index} {...metric} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
